import useResizeObserver from "@react-hook/resize-observer";
import { useState, useLayoutEffect } from "react";

const useSize = (target) => {
  const [size, setSize] = useState({ x: 0, y: 0, width: 512, height: 512 });

  useLayoutEffect(() => {
    updateSize(target.current.getBoundingClientRect());
  }, [target]);

  function updateSize(bounds) {
    const size = Math.min(bounds.width, bounds.height);

    setSize({
      x: (bounds.width - size) / 2,
      y: (bounds.height - size) / 2,
      width: size,
      height: size,
    });
  }

  // Where the magic happens
  useResizeObserver(target, (entry) => {
    updateSize(entry.contentRect);
  });
  return size;
};

export default useSize;
